import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient, HttpEvent, HttpRequest} from '@angular/common/http';

@Injectable()
export class UtilityService {
  private nodeId: number;
  private strictNode: boolean;
  private targetNodeExists = true;

  constructor(private http: HttpClient) { }


  getTargetNodeExists(): boolean {
    return this.targetNodeExists;
  }

  getNodeId(): number {
    return this.nodeId;
  }

  setNodeId(value: number) {
    this.nodeId = value;
  }

  isNodeStrict() {
    return this.strictNode;
  }

  setStrictNode(value: boolean) {
    this.strictNode = value;
  }

  setTargerNodeExists(b: boolean) {
    this.targetNodeExists = b;
  }
}
